/*------------------------------------------------------------------
Imports
------------------------------------------------------------------*/

import SiriWave from 'scripts/components/siri-wave';
import { Howl, Howler } from 'howler';

/*------------------------------------------------------------------
Audio Blocks
------------------------------------------------------------------*/

// Store all the audio objects in this object
const AudioBlocks = {};
Watcher.observe('.js-default-audio', blocks => {
  // Loop the blocks array
  blocks.forEach(block => {
    // Find the media element
    const media = block.querySelector('[data-audio-file]');
    // Create a new object to control the audio
    const Audio = {};

    // Create a new SiriWave object for the Audio
    Audio.Wave = new SiriWave({
      container: media,
      color: media.getAttribute('data-colour') == 'light' ? '#000000' : '#ffffff',
      cover: true,
      speed: .02,
      amplitude: .65,
      frequency: 2
    });

    // Create a new Howler object for the Audio
    Audio.Player = new Howl({
      src: [media.getAttribute('data-audio-file')],
      loop: false,
      onend() {
        this.stop();
        Audio.Wave.stop();
        media.classList.remove('playing');
      }
    });

    // When the media element is clicked
    media.addEventListener('click', e => {
      // Prevent the default action
      e.preventDefault();

      // If the audio is playing, stop it
      if (Audio.Player.playing()) {
        media.classList.remove('playing');
        Audio.Player.pause();
        Audio.Wave.stop();
        return;
      }

      // If the audio is not playing, stop all other audio and play this one
      Object.keys(AudioBlocks).forEach(key => {
        AudioBlocks[key].Player.pause();
        AudioBlocks[key].Wave.stop();
      });
      Audio.Player.play();
      Audio.Wave.start();
      media.classList.add('playing');
    });

    // Add the Audio to the AudioBlocks object
    AudioBlocks[block.id] = Audio;
  });
});